import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, AlertTriangle } from 'lucide-react';
const painPoints = [{
  title: 'Entrás a guardia sin saber qué hacer',
  desc: 'Sin protocolo claro para cada urgencia que aparece.',
  emoji: '😰'
}, {
  title: 'Ves el ECG y te quedás en blanco',
  desc: 'Sin método sistemático que te guíe paso a paso.',
  emoji: '📉'
}, {
  title: 'Los residentes te preguntan y no respondés',
  desc: 'Sin el razonamiento clínico que se espera de vos.',
  emoji: '🤐'
}, {
  title: 'Los libros son densos y en inglés',
  desc: 'Sin material visual y práctico en español rioplatense.',
  emoji: '📚'
}, {
  title: 'No sabés qué dosis dar ni qué droga pedir',
  desc: 'Sin referencia rápida accesible en el momento crítico.',
  emoji: '💊'
}, {
  title: 'Memorizás pero no entendés',
  desc: 'Sin conexión entre la teoría de la facultad y la realidad de guardia.',
  emoji: '🧠'
}, {
  title: 'No reconocés los signos de alarma',
  desc: 'Tu evaluación inicial es lenta, insegura y sin criterio.',
  emoji: '🚨'
}, {
  title: 'Sin casos clínicos reales para entrenar',
  desc: 'No podés simular guardias antes de estar frente al paciente.',
  emoji: '🩺'
}];
export function PainPoints() {
  return <section className="py-16 px-4 bg-white relative overflow-hidden" data-id="element-172">
      {/* Background accent */}
      <div className="absolute top-0 right-0 w-72 h-72 bg-red-50 rounded-full blur-3xl opacity-50 -translate-y-1/2 translate-x-1/2" data-id="element-173"></div>

      <div className="max-w-5xl mx-auto relative" data-id="element-174">
        <div className="text-center mb-12" data-id="element-175">
          <div className="inline-flex items-center gap-2 bg-red-50 text-urgency-red font-bold px-4 py-1.5 rounded-full text-xs mb-4 tracking-widest" data-id="element-176">
            <AlertTriangle size={14} data-id="element-177" />
            REALIDAD DE GUARDIA
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-extrabold text-gray-900 mb-3" data-id="element-178">
            ¿TE PASA ESTO?
          </h2>
          <p className="text-lg text-gray-600 font-medium max-w-2xl mx-auto" data-id="element-179">
            Si sos estudiante de medicina en Argentina, esto te suena familiar:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-10" data-id="element-180">
          {painPoints.map((point, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: i % 2 === 0 ? -20 : 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-30px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="bg-white rounded-xl p-4 border border-gray-100 shadow-sm hover:shadow-md transition-shadow flex items-start gap-4 group" data-id="element-181">
              <div className="bg-red-50 group-hover:bg-red-100 transition-colors w-12 h-12 rounded-xl flex items-center justify-center text-2xl shrink-0" data-id="element-182">
                {point.emoji}
              </div>
              <div className="flex-1 min-w-0" data-id="element-183">
                <h3 className="font-bold text-gray-900 text-sm md:text-base leading-tight mb-1 flex items-center gap-2" data-id="element-184">
                  <AlertCircle size={14} className="text-urgency-red shrink-0" data-id="element-185" />
                  {point.title}
                </h3>
                <p className="text-xs md:text-sm text-gray-500" data-id="element-186">{point.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-urgency-red rounded-2xl p-6 md:p-8 text-center max-w-3xl mx-auto shadow-xl relative overflow-hidden" data-id="element-187">
          <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/diagmonds.png')] opacity-10" data-id="element-188"></div>
          <p className="text-white font-heading font-bold text-lg md:text-2xl relative leading-tight" data-id="element-189">
            ¿Cuántas guardias más vas a hacer sin un sistema visual que respalde
            cada decisión clínica?
          </p>
        </motion.div>
      </div>
    </section>;
}